import React from 'react';

import { BillToAddressCard } from '../../../../../../components/cards/company';
import { AdditionalAttachmentCard } from '../../../../../../components/cards/financial/AttachmentCard';
import PrivacyPolicyCard from '../../../../../../components/cards/financial/PrivacyPolicyCard';
import { InvoiceDeliveryContactCard } from '../../../../../../components/cards/shipTo';
import CompanyPage from '../../../../../../features/CompanyPage';
import { CARD_CATEGORIES } from '../../../../../../shared/cardConfig/constants';
import { ATTACHMENT_FIELDS, BILL_TO_ADDRESS_FIELDS,CONTACT_FIELDS } from '../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../utils/constants';

// ----------------- Type Definitions -----------------
interface Field {
  key: string;
  required?: boolean;
}

interface Card {
  key: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: React.ComponentType<any>;
  fields?: Field[];
  hideSameAs?: boolean;
  fieldWrapper?: string;
}

interface Page {
  route: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: React.ComponentType<any>;
  cards: Card[];
}

// ----------------- Page Template -----------------
const contactFields: Field[] = [
  { key: CONTACT_FIELDS.email },
  { key: CONTACT_FIELDS.fax }
];

const billToPageTemplate: Page = {
  route: PAGE_ROUTES.company,
  Component: CompanyPage,
  cards: [
    {
      key: CARD_CATEGORIES.billTo,
      Component: BillToAddressCard,
      hideSameAs: true,
      fields: [
        { key: BILL_TO_ADDRESS_FIELDS.address },
        { key: BILL_TO_ADDRESS_FIELDS.taxNumber1 },
        { key: BILL_TO_ADDRESS_FIELDS.taxNumber2 },
        { key: BILL_TO_ADDRESS_FIELDS.taxNumber3 },
        { key: BILL_TO_ADDRESS_FIELDS.taxNumber4 }
      ]
    },
    {
      key: CARD_CATEGORIES.invoiceDelivery,
      Component: InvoiceDeliveryContactCard,
      fields: [...contactFields],
      fieldWrapper: CARD_CATEGORIES.shipTo + '[0]'
    },
    {
      key: CARD_CATEGORIES.additionalAttachmentCard,
      Component: AdditionalAttachmentCard,
      fields: [{ key: ATTACHMENT_FIELDS.additionalAttachment }]
    },
    {
      key: CARD_CATEGORIES.privacyPolicy,
      Component: PrivacyPolicyCard
    }
  ]
};

// ----------------- Export Pages -----------------
const pages: Page[] = [billToPageTemplate];

export default pages;